import { customScrollbar, tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Header = styled.div`
	margin: 24px 0;
	display: grid;
	gap: 16px;
`;

export const HeaderRow = styled.tr`
	height: 40px;
	position: sticky;
	top: 0px;
	z-index: 1;
	background-color: ${tokens.color_gray_light};
`;

export const TableHead = styled.th<{ $width: string }>`
	width: ${({ $width }) => $width} !important;
	padding: 10px;
	font-size: 14px;
	font-weight: 600;
	font-family: ${tokens.font_family_primary};
	color: ${tokens.color_gray_dark};
	text-align: left;
`;

export const TableCell = styled.td<{ $padding?: string }>`
	padding: ${({ $padding }) => $padding || '10px'};
	border-bottom: 1px solid ${tokens.color_gray_light};
	background-color: ${tokens.color_white};
	font-size: 14px;
	font-weight: 500;
	font-family: ${tokens.font_family_primary};
	color: ${tokens.color_gray_dark};
	align-content: start;

	button {
		display: flex;
		align-items: center;
		gap: 4px;
	}
`;

export const CopyWrapper = styled.span`
	display: flex;
	align-items: center;
`;

export const Footer = styled.div`
	display: flex;
	justify-content: center;
	padding: 24px 24px 0 24px;
`;

export const TableWrapper = styled.div`
	height: 300px;
	overflow: hidden scroll;

	table {
		width: 100%;
	}

	${customScrollbar}
`;
